<div class="modal-header">
  <h4 class="modal-title">{{ title | translate }}</h4>
  <button type="button" class="close" (click)="closeModal()">{{ 'addReservationModal.modalHeader.closeButton' | translate }}</button>
</div>
<div class="modal-body">
  <form id="film_group_form" #filmForm="ngForm" (ngSubmit)="addReservations()">
    <div class="form-group">
      <label for="filmInput">{{ 'addReservationModal.form.filmLabel' | translate }}</label>
      <div class="input-group">
        <input id="filmInput"
               type="text"
               class="form-control"
               [(ngModel)]="selectedFilm"
               [ngbTypeahead]="searchFilms"
               [inputFormatter]="formatter"
               [resultFormatter]="formatter"
               placeholder="{{ 'addReservationModal.form.searchPlaceholder' | translate }}"
               (selectItem)="onFilmSelect($event)"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div id="nom_cine_div" class="group_prog_section form-group">
          <label class="gp_cine_label">{{ 'addReservationModal.form.cinemaLabel' | translate }}</label>
          <p>{{ cinema.liv_ville }} - {{ cinema.nom_cinema }}</p>
          <input name="id_cinema" [(ngModel)]="cinema.id_cinema" id="cinema_group_id" type="hidden" />
        </div>

        <div id="num_salle_cine" class="group_prog_section form-group">
          <label class="gp_cine_label" for="num_salle_field">{{ 'addReservationModal.form.screenLabel' | translate }}</label>
          <p id="num_salle_field" class="form-control-plaintext">{{ screen.nom_salle }}</p>
          <input name="screen_id" [(ngModel)]="screen.screen_id" id="screen_id" type="hidden" />
        </div>

        <div class="form-group">
          <label>{{ 'addReservationModal.form.dateStartLabel' | translate }}</label>
          <div class="input-group">
            <input class="form-control" [(ngModel)]="date" ngbDatepicker #d="ngbDatepicker"
                   name="dateStart" required  [firstDayOfWeek]="3" />
            <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
              <i class="bi bi-calendar3"></i>
            </button>
          </div>
        </div>

        <div class="form-group">
          <label class="gp_cine_label" for="gp_taux">{{ 'addReservationModal.form.rateLabel' | translate }}</label>
          <div class="input-group">
            <input type="text" id="gp_taux" maxlength="3" size="3" class="form-control" [(ngModel)]="taux" name="taux" />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="form-group">
          <label class="bold_text">{{ 'addReservationModal.form.versionsLabel' | translate }}</label>
          <div class="row">
            <div class="col-6" *ngFor="let version of versions">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" [id]="version.id_ver" [value]="version.id_ver" (change)="toggleVersion(version)" [checked]="version.checked" />
                <label class="form-check-label" [for]="version">{{ version.version_label }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label class="bold_text">{{ 'addReservationModal.form.durationLabel' | translate }}</label>
          <input type="text" id="gp_nb_week" name="week_nb" size="3" class="form-control" [(ngModel)]="duration" />
          <div class="form-check form-check-inline">
            <input type="radio" id="group_radio_semaine" class="form-check-input" name="type_duree" value="7" [(ngModel)]="durationType" />
            <label class="form-check-label" for="group_radio_semaine">{{ 'addReservationModal.form.weeksLabel' | translate }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input type="radio" id="group_radio_jour" class="form-check-input" name="type_duree" value="1" [(ngModel)]="durationType" />
            <label class="form-check-label" for="group_radio_jour">{{ 'addReservationModal.form.daysLabel' | translate }}</label>
          </div>
        </div>

        <div id="gp_etat_reser" class="form-group">
          <label>{{ 'addReservationModal.form.reservationStatusLabel' | translate }}</label>
          <select class="form-control" [(ngModel)]="reservationStatus" name="reservationStatus">
            <option *ngFor="let status of listStatus" [value]="status.id">{{ status.label }}</option>
          </select>
        </div>

        <div id="gpci_type_copie" class="form-group">
          <label>{{ 'addReservationModal.form.copyTypeLabel' | translate }}</label>
          <select class="form-control" [(ngModel)]="copyType" name="copyType">
            <option *ngFor="let copy of copyTypes" [value]="copy.id">{{ copy.label }}</option>
          </select>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="adrc" [(ngModel)]="adrc" name="adrc"/>
          <label class="form-check-label" for="adrc">{{ 'addReservationModal.form.adrc' | translate }}</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="pdc" [(ngModel)]="pdc" name="pdc"/>
          <label class="form-check-label" for="pdc">{{ 'addReservationModal.form.pdc' | translate }}</label>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary validate-btn" (click)="filmForm.ngSubmit.emit()">{{ 'addReservationModal.modalFooter.saveButton' | translate }}</button>
</div>
